import { useCallback, useState } from 'react';

import { useHotkeys } from 'react-hotkeys-hook';
import { useKey } from 'react-use';

type Return = [boolean, () => void, () => void];

export const useSearch = (): Return => {
  const [open, setOpen] = useState(false);

  const openSearch = useCallback(() => {
    setOpen(true);
  }, []);

  const closeSearch = useCallback(() => {
    setOpen(false);
  }, []);

  useKey(
    event => open && (event.key === 'Escape' || event.key === 'Esc'),
    closeSearch,
  );

  useHotkeys('ctrl+k', event => {
    openSearch();
    event.preventDefault();
  });

  useHotkeys('command+k', event => {
    openSearch();
    event.preventDefault();
  });

  return [open, openSearch, closeSearch];
};
